module.exports = __webpack_public_path__ + "img/hr-V-L-5-unload-connect.eaf81aa4.png";